import React, {
  createContext,
  useContext,
  useReducer,
  useEffect,
  useCallback,
} from "react";

// Local storage key
// const CART_STORAGE_KEY = "mealinkr_cart";
function getSessionIdFromCookie() {
  const match = document.cookie.match(/(^| )session_id=([^;]+)/);
  return match ? match[2] : null;
}

function getCartStorageKey() {
  const sessionId = getSessionIdFromCookie();

  console.log('SEESION IS',sessionId);
  return sessionId ? `mealinkr_cart_${sessionId}` : "mealinkr_cart_temp";
}

// Initial state
const initialState = {
  items: [],
//   coupon: "",
//   serviceType: "", // "dinein" | "takeaway" | "roomservice"
//   instructions: "",
//   tableNumber: "",
//   roomNumber: "",
//   restaurantSettings: {
//     enable_table: true,
//     enable_room: false,
//     qsr: null, 
//     takeaway_packing_charge: null,
//     service_type: null,
//   },
};

// Reducer
function cartReducer(state, action) {
  switch (action.type) {
    case "ADD_ITEM": {
      const index = state.items.findIndex(
        (item) => item.item_id === action.payload.item_id
      );

      if (index > -1) {
        const newItems = [...state.items];
        newItems[index] = {
          ...newItems[index],
          qty: newItems[index].qty + 1,
        };

        return { ...state, items: newItems };
      }

      return {
        ...state,
        items: [...state.items, { ...action.payload, qty: 1 }],
      };
    }

    case "REMOVE_ITEM":
      return {
        ...state,
        items: state.items.filter((item) => item.item_id !== action.payload),
      };

    case "UPDATE_QTY": {
      const { id, qty } = action.payload;

      if (qty <= 0) {
        return {
          ...state,
          items: state.items.filter((item) => item.item_id !== id),
        };
      }

      return {
        ...state,
        items: state.items.map((item) =>
          item.item_id === id ? { ...item, qty } : item
        ),
      };
    }

    case "CLEAR_CART":
      return {
        ...state,
        items: [],
        coupon: "",
        serviceType: "dine-in",
        instructions: "",
        tableNumber: "",
        roomNumber: "",
      };

    case "SET_COUPON":
      return { ...state, coupon: action.payload };

    case "SET_SERVICE_TYPE":
      return { ...state, serviceType: action.payload };

    case "SET_INSTRUCTIONS":
      return { ...state, instructions: action.payload };

    case "SET_TABLE_NUMBER":
      return { ...state, tableNumber: action.payload };

    case "SET_ROOM_NUMBER":
      return { ...state, roomNumber: action.payload };

    case "SET_RESTAURANT_SETTINGS":
      return {
        ...state,
        restaurantSettings: {
          ...state.restaurantSettings,
          ...action.payload,
        },
      };

    case "LOAD_CART":
      return action.payload;

    default:
      return state;
  }
}

const CartContext = createContext();

// Provider
export function CartProvider({ children }) {
  // Context

  const [state, dispatch] = useReducer(cartReducer, initialState);

  // Load from localStorage
  // useEffect(() => {
  //   try {
  //     const saved = localStorage.getItem(CART_STORAGE_KEY);

  //     // console.log('local storage',)

  //     if (saved) {
  //       dispatch({
  //         type: "LOAD_CART",
  //         payload: JSON.parse(saved),
  //       });
  //     }
  //   } catch (err) {
  //     console.error(err);
  //   }
  // }, []);
  useEffect(() => {
    try {
      const key = getCartStorageKey();
      const saved = localStorage.getItem(key);
  
      if (saved) {
        dispatch({
          type: "LOAD_CART",
          payload: JSON.parse(saved),
        });
      } else {
        dispatch({ type: "CLEAR_CART" });
      }
    } catch (err) {
      console.error(err);
    }
  }, []);

  
  // Save to localStorage
  // useEffect(() => {
  //   localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(state));
  // }, [state]);
  useEffect(() => {
    const key = getCartStorageKey();
    localStorage.setItem(key, JSON.stringify(state));
  }, [state]);

  // Actions
  const addToCart = useCallback(
    (product) => dispatch({ type: "ADD_ITEM", payload: product }),
    []
  );

  const removeFromCart = useCallback(
    (id) => dispatch({ type: "REMOVE_ITEM", payload: id }),
    []
  );

  const updateQty = useCallback(
    (id, qty) => dispatch({ type: "UPDATE_QTY", payload: { id, qty } }),
    []
  );

  const clearCart = useCallback(() => dispatch({ type: "CLEAR_CART" }), []);

  const setCoupon = useCallback(
    (coupon) => dispatch({ type: "SET_COUPON", payload: coupon }),
    []
  );

  const setServiceType = useCallback(
    (type) => dispatch({ type: "SET_SERVICE_TYPE", payload: type }),
    []
  );

  const setInstructions = useCallback(
    (val) => dispatch({ type: "SET_INSTRUCTIONS", payload: val }),
    []
  );

  const setTableNumber = useCallback(
    (val) => dispatch({ type: "SET_TABLE_NUMBER", payload: val }),
    []
  );

  const setRoomNumber = useCallback(
    (val) => dispatch({ type: "SET_ROOM_NUMBER", payload: val }),
    []
  );

  const setRestaurantSettings = useCallback((settings) => {
    dispatch({
      type: "SET_RESTAURANT_SETTINGS",
      payload: settings,
    });
  }, []);

  // ================= CALCULATIONS =================

  const getSubtotal = () => {
    return state.items.reduce((sum, item) => sum + item.price * item.qty, 0);
  };

  const getGstTotal = () => {
    return state.items.reduce((sum, item) => {
      if (item.gst === 1) {
        return sum + item.price * 0.05 * item.qty;
      }
      return sum;
    }, 0);
  };

  const getTax = () => {
    return Math.round(getGstTotal());
  };

  // const getDiscount = () => {
  //   const coupons = {
  //     FIRST10: 0.1,
  //     SAVE20: 0.2,
  //     FLAT50: 50,
  //   };

  //   const subtotal = getSubtotal();
  //   const code = state.coupon.toUpperCase();

  //   if (coupons[code]) {
  //     const val = coupons[code];

  //     if (val < 1) return Math.round(subtotal * val);

  //     return val;
  //   }

  //   return 0;
  // };

  // ✅ PACKING CHARGE FIX
  const getPackingCharge = () => {
    if (state.serviceType !== "takeaway") return 0;

    const perItem = state.restaurantSettings?.takeaway_packing_charge || 0;

    const totalQty = state.items.reduce((sum, item) => sum + item.qty, 0);

    return Math.round(perItem * totalQty);
  };

// ✅ PLATFORM FEE (from API response)
const getPlatformFee = () => {
  return state.restaurantSettings?.platform_fee || 0;
};
  const getTotal = () => {
    const subtotal = getSubtotal();
    const tax = getTax();
    // const discount = getDiscount();
    const packing = getPackingCharge();
    const platformFee = getPlatformFee();

    return Math.max(0, subtotal + tax + packing + platformFee);
  };

  const getItemCount = () => {
    return state.items.reduce((sum, item) => sum + item.qty, 0);
  };

  const isInCart = (id) => {
    return state.items.some((item) => item.item_id === id);
  };

  const getItemQty = (id) => {
    const item = state.items.find((item) => item.item_id === id);

    return item ? item.qty : 0;
  };

  // ================= VALUE =================

  const value = {
    // State
    items: state.items,
    coupon: state.coupon,
    serviceType: state.serviceType,
    instructions: state.instructions,
    tableNumber: state.tableNumber,
    roomNumber: state.roomNumber,
    restaurantSettings: state.restaurantSettings,

    // Actions
    addToCart,
    removeFromCart,
    updateQty,
    clearCart,
    setCoupon,
    setServiceType,
    setInstructions,
    setTableNumber,
    setRoomNumber,
    setRestaurantSettings,

    // Calculations
    getSubtotal,
    getTax,
    // getDiscount,
    getPackingCharge,
    getPlatformFee,
    getTotal,
    getItemCount,
    isInCart,
    getItemQty,
  };

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

// Hook
export function useCart() {
  const ctx = useContext(CartContext);

  if (!ctx) {
    throw new Error("useCart must be used inside CartProvider");
  }

  return ctx;
}

export default CartContext;
